import { object, string } from 'yup';
import { api } from '../../../hooks/api.hooks';

export const initialValues = {
  password: '',
  email: '',
};

export const validationSchema = [
  object().shape({
    password: string()
      .required('error.input.required')
      .test('is-correct', 'error.server.wrong_credentials', async (value, testContext) => {
        try {
          await api.post('/access-keys/password/verify', { password: value });
          return true;
        } catch (err: any) {
          if (err.response.status !== 400) {
            return testContext.createError({ message: 'error.server.unknown' });
          }
          return false;
        }
      }),
  }),
  object().shape({
    email: string().required('error.input.required').email('error.input.email'),
  }),
];
